import { format as jFormat, parse as jParse } from "date-fns-jalali";

export const formatHotelResultsV2Price = (price: number) =>
  price.toLocaleString("fa-IR");

export const toHotelResultsV2FaNumber = (value: number | string) =>
  String(value).replace(/\d/g, (digit) => "۰۱۲۳۴۵۶۷۸۹"[Number(digit)]);

export function parseHotelResultsV2Date(
  value: string | null | undefined,
  fallback = new Date(),
) {
  const fallbackDate = startOfDay(fallback);
  const parts = getDateParts(value);

  if (!parts) return fallbackDate;

  const { year, month, day } = parts;
  const isGregorianYear = year >= 1700;
  const parsed = isGregorianYear
    ? new Date(year, month - 1, day)
    : jParse(
        `${year}/${String(month).padStart(2, "0")}/${String(day).padStart(
          2,
          "0",
        )}`,
        "yyyy/MM/dd",
        fallbackDate,
      );

  parsed.setHours(0, 0, 0, 0);

  if (!Number.isFinite(parsed.getTime())) return fallbackDate;

  if (isGregorianYear) {
    if (
      parsed.getFullYear() !== year ||
      parsed.getMonth() !== month - 1 ||
      parsed.getDate() !== day
    ) {
      return fallbackDate;
    }

    return parsed;
  }

  if (
    Number(jFormat(parsed, "yyyy")) !== year ||
    Number(jFormat(parsed, "M")) !== month ||
    Number(jFormat(parsed, "d")) !== day
  ) {
    return fallbackDate;
  }

  return parsed;
}

function getDateParts(value: string | null | undefined) {
  const normalized = normalizeDateDigits(value ?? "");
  const match = normalized.match(/^(\d{4})[-/](\d{1,2})[-/](\d{1,2})$/);

  if (!match) return null;

  const [, year, month, day] = match;

  return {
    year: Number(year),
    month: Number(month),
    day: Number(day),
  };
}

function normalizeDateDigits(value: string) {
  return value
    .replace(/[۰٠]/g, "0")
    .replace(/[۱١]/g, "1")
    .replace(/[۲٢]/g, "2")
    .replace(/[۳٣]/g, "3")
    .replace(/[۴٤]/g, "4")
    .replace(/[۵٥]/g, "5")
    .replace(/[۶٦]/g, "6")
    .replace(/[۷٧]/g, "7")
    .replace(/[۸٨]/g, "8")
    .replace(/[۹٩]/g, "9")
    .trim();
}

function startOfDay(date: Date) {
  const nextDate = new Date(date);
  nextDate.setHours(0, 0, 0, 0);

  return nextDate;
}
